import { render, staticRenderFns } from "./InstallPwaAndroid.vue?vue&type=template&id=71f0eef6"
import script from "./InstallPwaAndroid.vue?vue&type=script&lang=js"
export * from "./InstallPwaAndroid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports